import mqtt from "mqtt";

const DEFAULT_HOST = process.env.REACT_APP_MQTT_HOST || "eeb1e83a06da4b44b7a340bc19cd1e75.s1.eu.hivemq.cloud";
const DEFAULT_PORT = process.env.REACT_APP_MQTT_PORT || "8884";
const DEFAULT_USER = process.env.REACT_APP_MQTT_USER || "cput_energy";
const DEFAULT_PASS = process.env.REACT_APP_MQTT_PASS || "Hnk@2026";

export const TOPICS = {
  STATE:      "campus/energy/state",
  CMD:        "campus/energy/cmd",
  CAM_CMD:    "campus/camera/cmd",
  CAM_IMG:    "campus/camera/img",
  CAM_STATE:  "campus/camera/state",
  CAM_MOTION: "campus/camera/motion",
};

let client = null;

function createClient(host, port, user, pass) {
  const url = `wss://${host}:${port}/mqtt`;
  return mqtt.connect(url, {
    username: user,
    password: pass,
    clientId: `cem_web_${Math.random().toString(16).slice(2, 10)}`,
    keepalive: 60,
    reconnectPeriod: 3000,
    connectTimeout: 12000,
    clean: true,
  });
}

export function getMqttClient() {
  if (client) return client;
  client = createClient(DEFAULT_HOST, DEFAULT_PORT, DEFAULT_USER, DEFAULT_PASS);
  return client;
}

export function reconnectMqtt(host, user, pass) {
  if (client) { client.end(true); client = null; }
  client = createClient(host || DEFAULT_HOST, DEFAULT_PORT, user || DEFAULT_USER, pass || DEFAULT_PASS);
  return client;
}

export function publishCmd(device, action) {
  const c = getMqttClient();
  if (!c.connected) throw new Error("MQTT not connected");
  c.publish(TOPICS.CMD, JSON.stringify({ cmd: device, val: action }), { qos: 0 });
}

export function publishCamCmd(cmd) {
  const c = getMqttClient();
  if (!c.connected) throw new Error("MQTT not connected");
  c.publish(TOPICS.CAM_CMD, String(cmd), { qos: 0 });
}

export function disconnectMqtt() {
  if (client) { client.end(true); client = null; }
}
